import { Flex, Theme } from "@radix-ui/themes";
// @ts-expect-error - no types for virtual modules
import "@radix-ui/themes/styles.css";
import { registerSW } from "virtual:pwa-register";
import { PostHogProvider } from "posthog-js/react";
import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { KeyboardLoader } from "./app/components/Loaders/KeyboardLoader.component";
import type { BeforeInstallPromptEvent } from "./app/stores/pwa/pwa.store";
import { usePwaStore } from "./app/stores/pwa/pwa.store";
import { openDatabaseConnection } from "./global/database/database";
import { GlobalTheme } from "./theme/global.theme";

registerSW();

window.addEventListener("beforeinstallprompt", (event) => {
	event.preventDefault();
	usePwaStore
		.getState()
		.setInstallPrompt(event as unknown as BeforeInstallPromptEvent);
});

window.addEventListener("appinstalled", () => {
	usePwaStore.getState().setInstalled();
});

const options = {
	api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
	defaults: "2025-05-24",
} as const;

const AppComponent = lazy(async () => ({
	default: await import("./app/App").then((mod) => mod.App),
}));
// biome-ignore lint/style/noNonNullAssertion: root element is guaranteed by index.html
const root = createRoot(document.getElementById("root")!);

root.render(
	<StrictMode>
		<PostHogProvider
			apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
			options={options}
		>
			<Theme accentColor="gray">
				<GlobalTheme />
				<Flex
					height="100dvh"
					width="100dvw"
					direction="column"
					align="center"
					justify="center"
				>
					<KeyboardLoader />
				</Flex>
			</Theme>
		</PostHogProvider>
	</StrictMode>,
);

Promise.all([openDatabaseConnection()]).then(() => {
	root.render(
		<StrictMode>
			<PostHogProvider
				apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
				options={options}
			>
				<Theme accentColor="gray">
					<GlobalTheme />
					<Suspense
						fallback={
							<Flex
								height="100dvh"
								width="100dvw"
								direction="column"
								align="center"
								justify="center"
							>
								<KeyboardLoader />
							</Flex>
						}
					>
						<AppComponent />
					</Suspense>
				</Theme>
			</PostHogProvider>
		</StrictMode>,
	);
});
